const state = {
    isAuthenticated: null,
    isAuthDataSet: false,
    user: {
        authEmail: null,
        doctorId: null,
        connectId: null
    }
};
export default state;
